// @ts-nocheck
import { LANGUAGES } from 'Jsx/global.d';

interface TranslationKey {
  page: string;
  language: string;
  keys: Key[];
}

interface Key {
  name: string;
  value: string;
}

interface FallbackLang {
  [key: string]: {
    translation: {
      [key: string]: string;
    };
  };
}

export const HOME_TRANSLATION_KEY = 'home';
export const HOME_USER_TRANSLATION_KEY = 'home-user';
export const CATALOG_TRANSLATION_KEY = 'catalog';
export const SIGNUP_TRANSLATION_KEY = 'signup';
export const LOGIN_TRANSLATION_KEY = 'login';
export const THANK_YOU_TRANSLATION_KEY = 'thank-you';
export const MEMBERSHIP_LANDING_TRANSLATION_KEY = 'membership-landing';
export const COURSE_DETAIL_TRANSLATION_KEY = 'course-detail';
export const MAIN_MENU_KEY = 'main-menu';
export const MAIN_FOOTER_KEY = 'main-footer';
export const LESSONS_TRANSLATION_KEY = 'lesson';
export const PLAYER_TRANSLATION_KEY = 'lesson-player';
export const USER_PANEL_TRANSLATION_KEY = 'user-panel';
export const INBOX_TRANSLATION_KEY = 'inbox';
export const CHECKOUT_TRANSLATION_KEY = 'checkout';
export const CUSTOM_BUNDLE_LANDING_TRANSLATION_KEY = 'custom-bundle';
export const COURSE_LANDING_TRANSLATION_KEY = 'course-landing';
export const SHOPPING_CART_TRANSLATION_KEY = 'shopping-cart';
export const AUTHGUEST_TRANSLATION_KEY = 'auth-guest';
export const AUTH_REFERFRIEND_TRANSLATION_KEY = 'auth-refer-friend';
export const RECOVER_PASSWORD_TRANSLATION_KEY = 'recover-password';
export const CHANGE_PASSWORD_TRANSLATION_KEY = 'change-password';
export const WELCOME_FLUX_TRANSLATION_KEY = 'welcome-flux';
export const GIFT_MEMBERSHIP_PAGE = 'gift-membership';

export const NAMESPACE_FALLBACK = [
  HOME_TRANSLATION_KEY,
  HOME_USER_TRANSLATION_KEY,
  CATALOG_TRANSLATION_KEY,
  SIGNUP_TRANSLATION_KEY,
  LOGIN_TRANSLATION_KEY,
  THANK_YOU_TRANSLATION_KEY,
  MEMBERSHIP_LANDING_TRANSLATION_KEY,
  COURSE_DETAIL_TRANSLATION_KEY,
  MAIN_MENU_KEY,
  MAIN_FOOTER_KEY,
  MAIN_FOOTER_KEY,
  LESSONS_TRANSLATION_KEY,
  PLAYER_TRANSLATION_KEY,
  USER_PANEL_TRANSLATION_KEY,
  INBOX_TRANSLATION_KEY,
  CHECKOUT_TRANSLATION_KEY,
  CUSTOM_BUNDLE_LANDING_TRANSLATION_KEY,
  COURSE_LANDING_TRANSLATION_KEY,
  SHOPPING_CART_TRANSLATION_KEY,
  AUTHGUEST_TRANSLATION_KEY,
  AUTH_REFERFRIEND_TRANSLATION_KEY,
  RECOVER_PASSWORD_TRANSLATION_KEY,
  CHANGE_PASSWORD_TRANSLATION_KEY,
  WELCOME_FLUX_TRANSLATION_KEY,
  GIFT_MEMBERSHIP_PAGE,
];

export const currentLanguage =
  typeof window !== 'undefined' &&
  window.__INITIAL_STATE__ &&
  window.__INITIAL_STATE__.LANGUAGE_KEY
    ? window.__INITIAL_STATE__.LANGUAGE_KEY
    : 'es';

const selectFallback = (
  fallbackEs: FallbackLang,
  fallbackPt: FallbackLang,
  language?: LANGUAGES,
) =>
  (language || currentLanguage) === 'pt'
    ? fallbackPt.pt.translation
    : fallbackEs.es.translation;

const getTranslation = (
  { page, keys }: TranslationKey,
  currentPage: string,
  fallbackEs: FallbackLang,
  fallbackPt: FallbackLang,
  language?: LANGUAGES,
) => ({
  ...(page === currentPage
    ? selectFallback(fallbackEs, fallbackPt, language)
    : {}),
  ...Object.assign({}, ...keys.map(item => ({ [item.name]: item.value }))),
});

const transformKeys = (
  translationKeys: TranslationKey[] | null,
  fallbackEs: FallbackLang,
  fallbackPt: FallbackLang,
  pageKey: string,
  language?: LANGUAGES,
) => ({
  translations: translationKeys
    ? {
        [translationKeys[0].language]: translationKeys.reduce(
          (acc, c) => ({
            ...acc,
            [pageKey]: selectFallback(fallbackEs, fallbackPt),
            [c.page]: getTranslation(
              c,
              pageKey,
              fallbackEs,
              fallbackPt,
              language,
            ),
          }),
          {},
        ),
      }
    : {
        [currentLanguage]: {
          [pageKey]: selectFallback(fallbackEs, fallbackPt),
        },
      },
  currentLanguage: language || currentLanguage,
});

export default transformKeys;
